// File: src/pages/candidate/CandidateProfilePage.jsx
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../../utils/cropImage';
import '../../css/HomePage.css';
import { QRCodeCanvas } from 'qrcode.react'; // Nhớ cài npm install qrcode.react


// --- ICONS ---
const IconPencil = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const IconBriefcase = (props) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const IconSchool = (props) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>;
const IconPlus = (props) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const IconMapPin = (props) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;
const IconMail = (props) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>;
const IconPhone = (props) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>;
const IconTrash = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#EF4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>;
const IconCamera = (props) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>;
const IconClose = (props) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>;
const IconFacebook = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>;
const IconInstagram = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>;
const IconLinkedIn = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>;
const IconGitHub = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>;
const IconGlobe = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>;
const IconShare = (props) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>;
const IconMagic = (props) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#F59E0B" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 2L16.5 3.5L18 4L16.5 4.5L16 6L15.5 4.5L14 4L15.5 3.5L16 2Z" fill="#FCD34D" /><path d="M20 12L20.5 13.5L22 14L20.5 14.5L20 16L19.5 14.5L18 14L19.5 13.5L20 12Z" fill="#FCD34D" /></svg>;


// Helper
const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('vi-VN', { month: '2-digit', year: 'numeric' });
};

const SUGGESTED_SKILLS = [
    "ReactJS", "Node.js", "JavaScript", "TypeScript", "Python", "Java", "C#", "SQL", "MongoDB",
    "Git", "Docker", "AWS", "Communication", "Teamwork", "English", "Japanese"
];

const IconVerified = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '8px', verticalAlign: 'middle' }}>
        <path d="M22.5 12.5C22.5 12.98 22.13 13.43 21.94 13.88C21.73 14.37 21.68 14.93 21.77 15.45C21.87 16.03 21.7 16.63 21.31 17.06C20.92 17.49 20.35 17.69 19.78 17.69C19.25 17.69 18.72 17.85 18.3 18.17C17.84 18.52 17.52 19.03 17.4 19.59C17.29 20.16 16.92 20.66 16.39 20.91C15.86 21.16 15.24 21.09 14.73 20.72C14.26 20.38 13.68 20.25 13.11 20.36C12.54 20.47 11.97 20.85 11.66 21.36C11.35 21.87 10.78 22.14 10.21 22.07C9.64 22 9.13 21.64 8.84 21.13C8.58 20.67 8.16 20.32 7.66 20.16C7.11 19.98 6.54 20.08 6.07 20.43C5.6 20.78 4.99 20.84 4.47 20.59C3.95 20.34 3.59 19.84 3.49 19.27C3.4 18.71 3.09 18.2 2.64 17.85C2.22 17.53 1.69 17.37 1.16 17.37C0.59 17.37 0.02 17.17 -0.37 16.74C-0.76 16.31 -0.93 15.71 -0.83 15.13C-0.74 14.61 -0.79 14.05 -1 13.56C-1.19 13.11 -1.56 12.66 -1.56 12.18C-1.56 11.7 -1.19 11.25 -1 10.8C-0.79 10.31 -0.74 9.75 -0.83 9.23C-0.93 8.65 -0.76 8.05 -0.37 7.62C0.02 7.19 0.59 6.99 1.16 6.99C1.69 6.99 2.22 6.83 2.64 6.51C3.1 6.16 3.42 5.65 3.53 5.09C3.64 4.52 4.01 4.02 4.54 3.77C5.07 3.52 5.69 3.59 6.2 3.96C6.67 4.3 7.25 4.43 7.82 4.32C8.39 4.21 8.96 3.83 9.27 3.32C9.58 2.81 10.15 2.54 10.72 2.61C11.29 2.68 11.8 3.04 12.09 3.55C12.35 4.01 12.77 4.36 13.27 4.52C13.82 4.7 14.39 4.6 14.86 4.25C15.33 3.9 15.94 3.84 16.46 4.09C16.98 4.34 17.34 4.84 17.44 5.41C17.53 5.97 17.84 6.48 18.29 6.83C18.71 7.15 19.24 7.31 19.77 7.31C20.34 7.31 20.91 7.51 21.3 7.94C21.69 8.37 21.86 8.97 21.76 9.55C21.67 10.07 21.72 10.63 21.93 11.12C22.12 11.57 22.49 12.02 22.49 12.5Z" fill="#2563EB" />
        <path d="M15.41 8.59L9.99 14.01L7.16 11.18L5.75 12.59L9.99 16.84L16.83 10L15.41 8.59Z" fill="white" />
    </svg>
);

// --- COMPONENTS CON ---
const CustomModal = ({ isOpen, onClose, title, children, onSave }) => {
    if (!isOpen) return null;
    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button onClick={onClose} className="btn-close"><IconClose /></button>
                </div>
                <div className="modal-body">{children}</div>
                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose}>Hủy</button>
                    {onSave && <button className="btn-primary" onClick={onSave}>Lưu thông tin</button>}
                </div>
            </div>
        </div>
    );
};

const Toast = ({ message, type, onClose }) => {
    useEffect(() => { const timer = setTimeout(onClose, 3000); return () => clearTimeout(timer); }, [onClose]);
    return <div className={`toast-message ${type}`}>{message}</div>;
};

// ✅ Component Gợi ý trường đại học
const UniversitySearch = ({ value, onChange, onSelect }) => {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const handleSearch = async (text) => {
        onChange(text);
        if (text.length > 2) {
            try {
                // API tìm kiếm trường đại học
                const res = await fetch(`http://universities.hipolabs.com/search?name=${text}`);
                const data = await res.json();
                setSuggestions(data.slice(0, 5)); // Lấy 5 kết quả đầu
                setShowSuggestions(true);
            } catch (e) { console.error(e); }
        } else {
            setShowSuggestions(false);
        }
    };

    const handleSelectItem = (uni) => {
        onSelect(uni);
        setShowSuggestions(false);
    };

    return (
        <div className="uni-search-container" style={{ position: 'relative' }}>
            <input
                type="text"
                value={value}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Nhập tên trường (VD: FPT University)..."
                autoComplete="off"
            />
            {showSuggestions && (
                <div className="uni-dropdown">
                    {suggestions.map((uni, idx) => (
                        <div key={idx} className="uni-item" onClick={() => handleSelectItem(uni)}>
                            <div className="uni-icon">🎓</div>
                            <div>
                                <div className="uni-name">{uni.name}</div>
                                <div className="uni-web">{uni.domains[0]}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default function CandidateProfilePage() {

    const navigate = useNavigate();
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
    const fileInputRef = useRef(null);

    // STATE
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState(null);

    // Modal & Edit State
    const [activeModal, setActiveModal] = useState(null);
    const [editData, setEditData] = useState({});
    const [tempSkills, setTempSkills] = useState("");
    const [provinces, setProvinces] = useState([]); // ✅ Danh sách tỉnh thành

    // Crop State
    const [imageSrc, setImageSrc] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [aiResult, setAiResult] = useState(null);
    const [isAiLoading, setIsAiLoading] = useState(false);

    const handleAiProfileReview = async () => {
        setIsAiLoading(true);
        setActiveModal('ai_loading'); // Hiện modal loading
        try {
            const token = localStorage.getItem('skillmatch_token');
            const res = await fetch(`${apiBaseUrl}/api/ai/review-profile`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            setAiResult(data);
            setActiveModal('ai_result'); // Hiện kết quả
        } catch (error) {
            alert("Lỗi phân tích AI: " + error.message);
            setActiveModal(null);
        } finally {
            setIsAiLoading(false);
        }
    };
    const handleSaveSkills = () => {
        // Gộp kỹ năng từ ô nhập và các thẻ đã chọn
        const skillsArray = tempSkills.split(',').map(s => s.trim()).filter(Boolean);
        updateProfileAPI({ skills: skillsArray });
    };
    const toggleSkill = (skill) => {
        let currentSkills = tempSkills.split(',').map(s => s.trim()).filter(Boolean);
        if (currentSkills.includes(skill)) {
            currentSkills = currentSkills.filter(s => s !== skill);
        } else {
            currentSkills.push(skill);
        }
        setTempSkills(currentSkills.join(', '));
    };


    // FETCH DATA
    const fetchProfile = async () => {
        const token = localStorage.getItem('skillmatch_token');
        if (!token) return navigate('/login');
        try {
            const res = await fetch(`${apiBaseUrl}/api/users/profile`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setUserData(data);
            }
        } catch (error) { console.error(error); } finally { setLoading(false); }
    };

    // ✅ Fetch Provinces
    useEffect(() => {
        fetch('https://provinces.open-api.vn/api/?depth=1')
            .then(res => res.json())
            .then(data => setProvinces(data))
            .catch(err => console.error(err));
        fetchProfile();
    }, []);

    // API UPDATE
    const showToast = (message, type = 'success') => setToast({ message, type });
    const updateProfileAPI = async (payload) => {
    const token = localStorage.getItem('skillmatch_token');
    
    // Đảm bảo payload gửi đi chứa đúng những gì user đã nhập (kể cả chuỗi rỗng)
    console.log("Dữ liệu gửi lên Backend:", payload); 

    try {
        const res = await fetch(`${apiBaseUrl}/api/users/profile`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}` 
            },
            body: JSON.stringify(payload)
        });
        
        if (res.ok) {
            const data = await res.json();
            // ✅ CẬP NHẬT LẠI STATE NGAY LẬP TỨC
            setUserData(data.user); 
            showToast("Cập nhật thành công!");
            setActiveModal(null);
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Cuộn mượt mà
            });
        }
    } catch (error) {
        showToast("Lỗi kết nối", 'error');
    }
};
const validateProfile = (data) => {
    // 1. Kiểm tra các trường không được để trống
    if (!data.fullName?.trim()) {
        showToast("Họ và tên không được để trống", "error");
        return false;
    }
    if (!data.phone?.trim()) {
        showToast("Số điện thoại không được để trống", "error");
        return false;
    }

    // 2. Kiểm tra giới hạn ký tự
    if (data.fullName.length < 2 || data.fullName.length > 50) {
        showToast("Họ tên phải từ 2 đến 50 ký tự", "error");
        return false;
    }
    
    const phoneRegex = /^[0-9]{10,11}$/;
    if (!phoneRegex.test(data.phone)) {
        showToast("Số điện thoại phải là 10-11 chữ số", "error");
        return false;
    }

    if (data.title && data.title.length > 100) {
        showToast("Tiêu đề nghề nghiệp quá dài (tối đa 100 ký tự)", "error");
        return false;
    }

    if (data.bio && data.bio.length > 500) {
        showToast("Giới thiệu bản thân không nên quá 500 ký tự", "error");
        return false;
    }

    return true;
};

    // HANDLERS
    const handleSaveGeneral = () => {
    const payload = {
        fullName: editData.fullName || "",
        title: editData.title || "",
        phone: editData.phone || "",
        location: editData.location || "",
        bio: editData.bio || "",
        website: editData.website || "",
        socialLinks: editData.socialLinks || {}
    };

    if (validateProfile(payload)) {
        updateProfileAPI(payload);
    }
};

    const handleSaveExperience = () => {
        let updated = [...(userData.experience || [])];
        editData._id ? updated = updated.map(ex => ex._id === editData._id ? { ...ex, ...editData } : ex) : updated.push(editData);
        updateProfileAPI({ experience: updated });
    };
    const handleDeleteExperience = (id) => { if (window.confirm("Xóa kinh nghiệm này?")) { const updated = userData.experience.filter(ex => ex._id !== id); updateProfileAPI({ experience: updated }); } };

    const handleSaveEducation = () => {
        let updated = [...(userData.education || [])];
        // Nếu chọn trường từ API, có thể thêm logo
        if (editData.schoolDomain) {
            editData.logo = `https://logo.clearbit.com/${editData.schoolDomain}`; // ✅ Lấy logo từ clearbit
        }

        editData._id ? updated = updated.map(ed => ed._id === editData._id ? { ...ed, ...editData } : ed) : updated.push(editData);
        updateProfileAPI({ education: updated });
    };
    const handleDeleteEducation = (id) => { if (window.confirm("Xóa học vấn này?")) { const updated = userData.education.filter(e => e._id !== id); updateProfileAPI({ education: updated }); } };



    // CROP IMAGE HANDLERS
    const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // 1. Đọc file dưới dạng URL để hiển thị trong Cropper
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            setImageSrc(reader.result); // Lưu source ảnh
            setActiveModal('crop');     // ✅ Mở Modal Crop lên
        });
        reader.readAsDataURL(file);

        // Reset input để có thể chọn lại cùng 1 file nếu muốn
        e.target.value = null;
    };

    const handleSaveCroppedImage = async () => {
        try {
            // 1. Lấy Blob ảnh đã crop từ utility
            // Lưu ý: getCroppedImg của bạn phải trả về Blob. Nếu trả về URL, cần fetch(url).then(r => r.blob())
            const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);

            // 2. Tạo FormData để gửi lên API upload-avatar
            const formData = new FormData();
            formData.append('avatar', croppedBlob, 'avatar.jpg'); // Đặt tên file

            const token = localStorage.getItem('skillmatch_token');

            // 3. Gọi API Upload
            const res = await fetch(`${apiBaseUrl}/api/users/upload-avatar`, {
                method: 'POST',
                headers: {
                    'x-auth-token': token
                    // ⚠️ KHÔNG thêm Content-Type, để browser tự set boundary cho FormData
                },
                body: formData
            });

            const data = await res.json();

            if (res.ok) {
                // 4. Cập nhật giao diện ngay lập tức
                setUserData(prev => ({
                    ...prev,
                    profile: { ...prev.profile, avatar: data.url }
                }));
                showToast("Cập nhật ảnh đại diện thành công!");
                setActiveModal(null); // Đóng modal
            } else {
                showToast("Lỗi upload ảnh", 'error');
            }

        } catch (e) {
            console.error(e);
            showToast("Lỗi xử lý ảnh", 'error');
        }
    };

    if (loading) return (
        <div className="min-h-screen pt-24 flex items-center justify-center bg-[#F8FAFC]">
            <span className="material-symbols-outlined animate-spin text-3xl text-blue-600">sync</span>
        </div>
    );
    const profile = userData.profile || {};



    return (
        <div className="profile-page-container">
            {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

            {/* HEADER CARD */}
            <div className="profile-card header-card">
                <div className="cover-photo"></div>
                <button
                    className="btn-edit-absolute"
                    onClick={() => {
                        setEditData({
                            ...profile,
                            email: userData.email, // ✅ Load email hiện tại
                            // ✅ Load SĐT từ root hoặc profile
                            phone: userData.phone || profile.phoneNumber,
                            socialLinks: profile.socialLinks || {}
                        });
                        setActiveModal('general');
                    }}
                >
                    <IconPencil />
                </button>
                <button
                    className="btn-edit-absolute"
                    style={{ right: '120px', background: 'linear-gradient(135deg, #4F46E5, #7C3AED)' }}
                    onClick={handleAiProfileReview}
                    title="AI Chấm điểm Profile"
                >
                    {isAiLoading ? <span className="material-symbols-outlined animate-spin text-sm">sync</span> : <IconMagic />}
                </button>
                <button
                    className="btn-edit-absolute"
                    style={{ right: '70px' }} // Cách nút Edit ra một chút
                    onClick={() => setActiveModal('share')}
                >
                    <IconShare /> {/* Bạn tự thêm icon Share vào list icon nhé */}
                </button>
                <div className="header-i">
                    <div className="avatar-wrapper" onClick={() => fileInputRef.current.click()}>
                        {profile.avatar ? <img src={profile.avatar} alt="Avatar" className="avatar-img" /> : <div className="avatar-placeholder">{profile.fullName?.charAt(0) || 'U'}</div>}
                        <div className="avatar-overlay"><IconCamera /></div>
                        <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/*" onChange={handleFileChange} />
                    </div>

                    <div className="user-details">
                        <div className="user-name-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                            <h1 className="user-name">{profile.fullName}</h1>
                            <IconVerified />
                        </div>
                        <p className="user-headline">{profile.headline || "Thêm chức danh (VD: Fullstack Developer)"}</p>

                        <div className="user-meta">
                            {profile.location && <span><IconMapPin /> {profile.location}</span>}
                            {userData?.email && <span><IconMail /> {userData.email}</span>}
                            {(profile.phoneNumber || userData?.phone) && <span><IconPhone /> {profile.phoneNumber || userData?.phone}</span>}
                        </div>

                        {/* ✅ FIX BIO: Đưa ra thành khối riêng biệt, căn giữa */}
                        {profile.bio && (
                            <div className="bio-container">
                                <p className="user-bio">"{profile.bio}"</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* MAIN CONTENT */}
            <div className="profile-grid">
                <div className="profile-left-col">
                    {/* Experience */}
                    <div className="profile-card">
                        <div className="card-header"><h2>Kinh nghiệm làm việc</h2><button className="btn-icon" onClick={() => { setEditData({}); setActiveModal('exp'); }}><IconPlus /></button></div>
                        <div className="card-body">
                            {userData.experience?.length > 0 ? (
                                <div className="timeline-list">
                                    {userData.experience.map((exp, idx) => (
                                        <div key={idx} className="timeline-item">
                                            <div className="timeline-icon"><IconBriefcase /></div>
                                            <div className="timeline-content">
                                                <div className="item-header">
                                                    <div><h3 className="item-title">{exp.position}</h3><p className="item-subtitle">{exp.company}</p><p className="item-date">{formatDate(exp.startDate)} - {exp.current ? 'Hiện tại' : formatDate(exp.endDate)}</p></div>
                                                    <div className="item-actions"><button onClick={() => { setEditData(exp); setActiveModal('exp'); }}><IconPencil /></button><button onClick={() => handleDeleteExperience(exp._id)} className="text-red"><IconTrash /></button></div>
                                                </div>
                                                {exp.description && <p className="item-desc">{exp.description}</p>}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : <p className="empty-state">Chưa có thông tin kinh nghiệm.</p>}
                        </div>
                    </div>
                    {/* Education */}
                    <div className="profile-card">
                        <div className="card-header"><h2>Học vấn</h2><button className="btn-icon" onClick={() => { setEditData({}); setActiveModal('edu'); }}><IconPlus /></button></div>
                        <div className="card-body">
                            {userData.education?.length > 0 ? (
                                <div className="timeline-list">
                                    {userData.education.map((edu, idx) => (
                                        <div key={idx} className="timeline-item">
                                            <div className="timeline-icon school">
                                                {/* ✅ Hiển thị Logo trường nếu có */}
                                                {edu.logo ? <img src={edu.logo} alt="logo" style={{ width: '100%', borderRadius: 8 }} /> : <IconSchool />}
                                            </div>
                                            <div className="timeline-content">
                                                <div className="item-header">
                                                    <div><h3 className="item-title">{edu.school}</h3><p className="item-subtitle">{edu.degree} - {edu.fieldOfStudy}</p><p className="item-date">{formatDate(edu.startDate)} - {formatDate(edu.endDate)}</p></div>
                                                    <div className="item-actions"><button onClick={() => { setEditData(edu); setActiveModal('edu'); }}><IconPencil /></button><button onClick={() => handleDeleteEducation(edu._id)} className="text-red"><IconTrash /></button></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : <p className="empty-state">Chưa có thông tin học vấn.</p>}
                        </div>
                    </div>
                </div>
                {/* Right Col */}
                <div className="profile-right-col">
                    <div className="profile-card">
                        <div className="card-header"><h2>Kỹ năng</h2><button className="btn-icon" onClick={() => { setTempSkills(userData.skills ? userData.skills.join(', ') : ""); setActiveModal('skill'); }}><IconPencil /></button></div>
                        <div className="card-body"><div className="skills-container">{userData.skills?.length > 0 ? userData.skills.map((skill, i) => <span key={i} className="skill-tag">{skill}</span>) : <p className="empty-state">Chưa có kỹ năng.</p>}</div></div>
                    </div>
                    <div className="profile-card">
                        <div className="card-header"><h2>Liên kết</h2></div>
                        <div className="card-body link-list">
                            {profile.website && <a href={profile.website} target="_blank" rel="noreferrer" className="link-item"><IconGlobe /> Website cá nhân</a>}
                            {profile.socialLinks?.linkedin && <a href={profile.socialLinks.linkedin} target="_blank" rel="noreferrer" className="link-item"><IconLinkedIn /> LinkedIn</a>}
                            {profile.socialLinks?.github && <a href={profile.socialLinks.github} target="_blank" rel="noreferrer" className="link-item"><IconGitHub /> GitHub</a>}
                            {profile.socialLinks?.facebook && <a href={profile.socialLinks.facebook} target="_blank" rel="noreferrer" className="link-item"><IconFacebook /> Facebook</a>}
                            {/* ... more links */}
                            {!profile.website && !profile.socialLinks?.linkedin && !profile.socialLinks?.github && <p className="empty-state">Chưa có liên kết nào.</p>}
                        </div>
                    </div>
                </div>
            </div>

            {/* --- MODALS --- */}

            {/* 1. GENERAL (Cập nhật Email, SĐT, Địa điểm API) */}
            <CustomModal isOpen={activeModal === 'general'} onClose={() => setActiveModal(null)} title="Chỉnh sửa thông tin cá nhân" onSave={handleSaveGeneral}>
                <div className="form-grid">
                    <div className="form-group"><label>Họ và tên</label><input type="text" value={editData.fullName || ''} onChange={e => setEditData({ ...editData, fullName: e.target.value })} /></div>
                    <div className="form-group"><label>Headline</label><input type="text" value={editData.title || ''} onChange={e => setEditData({ ...editData, title: e.target.value })} placeholder="VD: Senior React Developer" /></div>

                    {/* ✅ Email & Phone */}
                    <div className="form-row">
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" value={editData.email || ''} onChange={e => setEditData({ ...editData, email: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>Số điện thoại</label>
                            <input type="text" value={editData.phone || ''} onChange={e => setEditData({ ...editData, phone: e.target.value })} />
                        </div>
                    </div>

                    {/* ✅ Địa điểm từ API */}
                    <div className="form-group">
                        <label>Địa điểm</label>
                        <select
                            value={editData.location || ''}
                            onChange={e => setEditData({ ...editData, location: e.target.value })}
                            style={{ padding: '10px', border: '1px solid #D1D5DB', borderRadius: '6px' }}
                        >
                            <option value="">Chọn Tỉnh/Thành phố</option>
                            {provinces.map(p => (
                                <option key={p.code} value={p.name}>{p.name}</option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group"><label>Giới thiệu</label><textarea rows="4" value={editData.bio || ''} onChange={e => setEditData({ ...editData, bio: e.target.value })}></textarea></div>

                    {/* ✅ Social Links mở rộng */}
                    <div className="form-group"><label>Website / Portfolio</label><input type="text" value={editData.website || ''} onChange={e => setEditData({ ...editData, website: e.target.value })} placeholder="https://" /></div>

                    <div className="form-row">
                        <div className="form-group"><label>LinkedIn</label><input type="text" value={editData.socialLinks?.linkedin || ''} onChange={e => setEditData({ ...editData, socialLinks: { ...editData.socialLinks, linkedin: e.target.value } })} /></div>
                        <div className="form-group"><label>GitHub</label><input type="text" value={editData.socialLinks?.github || ''} onChange={e => setEditData({ ...editData, socialLinks: { ...editData.socialLinks, github: e.target.value } })} /></div>
                    </div>
                    <div className="form-row">
                        <div className="form-group"><label>Facebook</label><input type="text" value={editData.socialLinks?.facebook || ''} onChange={e => setEditData({ ...editData, socialLinks: { ...editData.socialLinks, facebook: e.target.value } })} /></div>
                        <div className="form-group"><label>Instagram</label><input type="text" value={editData.socialLinks?.instagram || ''} onChange={e => setEditData({ ...editData, socialLinks: { ...editData.socialLinks, instagram: e.target.value } })} /></div>
                    </div>
                </div>
            </CustomModal>

            {/* 2. EXPERIENCE */}
            <CustomModal isOpen={activeModal === 'exp'} onClose={() => setActiveModal(null)} title={editData._id ? "Cập nhật kinh nghiệm" : "Thêm kinh nghiệm"} onSave={handleSaveExperience}>
                <div className="form-grid">
                    <div className="form-group"><label>Chức vụ *</label><input type="text" value={editData.position || ''} onChange={e => setEditData({ ...editData, position: e.target.value })} /></div>
                    <div className="form-group"><label>Công ty *</label><input type="text" value={editData.company || ''} onChange={e => setEditData({ ...editData, company: e.target.value })} /></div>
                    <div className="form-row">
                        <div className="form-group"><label>Bắt đầu</label><input type="date" value={editData.startDate ? new Date(editData.startDate).toISOString().split('T')[0] : ''} onChange={e => setEditData({ ...editData, startDate: e.target.value })} /></div>
                        <div className="form-group"><label>Kết thúc</label><input type="date" value={editData.endDate ? new Date(editData.endDate).toISOString().split('T')[0] : ''} onChange={e => setEditData({ ...editData, endDate: e.target.value })} disabled={editData.current} /></div>
                    </div>
                    <div className="form-group checkbox-group"><input type="checkbox" id="currWork" checked={editData.current || false} onChange={e => setEditData({ ...editData, current: e.target.checked, endDate: null })} /><label htmlFor="currWork">Đang làm việc tại đây</label></div>
                    <div className="form-group"><label>Mô tả</label><textarea rows="4" value={editData.description || ''} onChange={e => setEditData({ ...editData, description: e.target.value })}></textarea></div>
                </div>
            </CustomModal>

            {/* 3. EDUCATION (API Trường Đại học) */}
            <CustomModal isOpen={activeModal === 'edu'} onClose={() => setActiveModal(null)} title={editData._id ? "Cập nhật học vấn" : "Thêm học vấn"} onSave={handleSaveEducation}>
                <div className="form-grid">
                    <div className="form-group">
                        <label>Trường học *</label>
                        {/* ✅ Tích hợp component Search */}
                        <UniversitySearch
                            value={editData.school || ''}
                            onChange={(val) => setEditData({ ...editData, school: val })}
                            onSelect={(uni) => setEditData({
                                ...editData,
                                school: uni.name,
                                schoolDomain: uni.domains[0] // Lưu domain để lấy logo sau này
                            })}
                        />
                    </div>
                    <div className="form-row">
                        <div className="form-group"><label>Bằng cấp</label><input type="text" value={editData.degree || ''} onChange={e => setEditData({ ...editData, degree: e.target.value })} /></div>
                        <div className="form-group"><label>Ngành học</label><input type="text" value={editData.fieldOfStudy || ''} onChange={e => setEditData({ ...editData, fieldOfStudy: e.target.value })} /></div>
                    </div>
                    <div className="form-row">
                        <div className="form-group"><label>Bắt đầu</label><input type="date" value={editData.startDate ? new Date(editData.startDate).toISOString().split('T')[0] : ''} onChange={e => setEditData({ ...editData, startDate: e.target.value })} /></div>
                        <div className="form-group"><label>Kết thúc</label><input type="date" value={editData.endDate ? new Date(editData.endDate).toISOString().split('T')[0] : ''} onChange={e => setEditData({ ...editData, endDate: e.target.value })} /></div>
                    </div>
                </div>
            </CustomModal>

            {/* 4. SKILLS */}
            <CustomModal isOpen={activeModal === 'skill'} onClose={() => setActiveModal(null)} title="Cập nhật kỹ năng" onSave={handleSaveSkills}>
                <div className="form-group">
                    <label>Kỹ năng đã chọn:</label>
                    <textarea rows="3" value={tempSkills} onChange={e => setTempSkills(e.target.value)} placeholder="ReactJS, Node.js..." />
                </div>
                <div className="form-group">
                    <label>Gợi ý kỹ năng phổ biến:</label>
                    <div className="skills-container" style={{ marginTop: 5 }}>
                        {SUGGESTED_SKILLS.map(skill => (
                            <span
                                key={skill}
                                className={`skill-tag suggestion ${tempSkills.includes(skill) ? 'selected' : ''}`}
                                onClick={() => toggleSkill(skill)}
                            >
                                {skill}
                            </span>
                        ))}
                    </div>
                </div>
            </CustomModal>
            <CustomModal isOpen={activeModal === 'share'} onClose={() => setActiveModal(null)} title="Skill Passport - Hồ sơ năng lực">
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <p style={{ color: '#6B7280', marginBottom: '24px' }}>
                        Sử dụng mã QR hoặc liên kết bên dưới để chia sẻ hồ sơ đã được xác thực của bạn với nhà tuyển dụng.
                    </p>

                    {/* QR CODE */}
                    <div style={{ background: 'white', padding: '16px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', display: 'inline-block', marginBottom: '24px', border: '1px solid #E5E7EB' }}>
                        <QRCodeCanvas
                            value={`${window.location.origin}/passport/${userData._id}`}
                            size={200}
                            level={"H"}
                            includeMargin={true}
                        />
                    </div>

                    {/* LINK COPY */}
                    <div style={{ display: 'flex', gap: '10px', background: '#F3F4F6', padding: '8px 12px', borderRadius: '8px', alignItems: 'center' }}>
                        <input
                            type="text"
                            readOnly
                            value={`${window.location.origin}/passport/${userData._id}`}
                            style={{ background: 'transparent', border: 'none', flex: 1, color: '#4B5563', fontSize: '13px' }}
                        />
                        <button
                            onClick={() => {
                                navigator.clipboard.writeText(`${window.location.origin}/passport/${userData._id}`);
                                showToast("Đã sao chép liên kết!");
                            }}
                            style={{ background: 'white', border: '1px solid #D1D5DB', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
                        >
                            Copy
                        </button>
                    </div>
                </div>
            </CustomModal>

            {/* 5. CROP IMAGE */}
            {activeModal === 'crop' && (
                <div className="modal-overlay">
                    <div className="modal-container" style={{ maxWidth: 500 }}>
                        <div className="modal-header"><h3>Chỉnh sửa ảnh đại diện</h3><button onClick={() => setActiveModal(null)} className="btn-close"><IconClose /></button></div>
                        <div className="modal-body" style={{ height: 300, position: 'relative' }}>
                            <Cropper
                                image={imageSrc}
                                crop={crop}
                                zoom={zoom}
                                aspect={1}
                                cropShape="round"
                                showGrid={false}
                                onCropChange={setCrop}
                                onZoomChange={setZoom}
                                onCropComplete={onCropComplete}
                            />
                        </div>
                        <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                            <div className="slider-container" style={{ flex: 1, marginRight: 20 }}>
                                <input type="range" value={zoom} min={1} max={3} step={0.1} onChange={(e) => setZoom(e.target.value)} style={{ width: '100%' }} />
                            </div>
                            <button className="btn-primary" onClick={handleSaveCroppedImage}>Lưu ảnh</button>
                        </div>
                    </div>
                </div>
            )}
            <CustomModal isOpen={activeModal === 'ai_result'} onClose={() => setActiveModal(null)} title="✨ AI Profile Review">
                {aiResult && (
                    <div className="ai-review-content">
                        <div className="score-circle">
                            <div className="score-number">{aiResult.score}</div>
                            <div className="score-label">Điểm hồ sơ</div>
                        </div>

                        <div className="review-section">
                            <h4>📝 Đánh giá tổng quan</h4>
                            <p>{aiResult.summary}</p>
                        </div>

                        <div className="review-grid">
                            <div className="review-col good">
                                <h4>✅ Điểm mạnh</h4>
                                <ul>{aiResult.strengths?.map((s, i) => <li key={i}>{s}</li>)}</ul>
                            </div>
                            <div className="review-col bad">
                                <h4>⚠️ Cần cải thiện</h4>
                                <ul>{aiResult.weaknesses?.map((s, i) => <li key={i}>{s}</li>)}</ul>
                            </div>
                        </div>

                        <div className="review-section highlight">
                            <h4>💡 Gợi ý Bio mới (Chuyên nghiệp hơn)</h4>
                            <div className="ai-rewrite-box">
                                <p>"{aiResult.rewrittenBio}"</p>
                                <button onClick={() => {
                                    setEditData({ ...profile, bio: aiResult.rewrittenBio });
                                    setActiveModal('general'); // Mở modal edit để user lưu lại
                                }}>Sử dụng Bio này</button>
                            </div>
                        </div>
                    </div>
                )}
            </CustomModal>

            {/* CSS NHÚNG TRỰC TIẾP */}
            <style>{`
            .score-circle { width: 100px; height: 100px; border-radius: 50%; background: #EFF6FF; color: #2563EB; display: flex; flex-direction: column; align-items: center; justify-content: center; margin: 0 auto 20px; border: 4px solid #BFDBFE; }
   .score-number { font-size: 32px; font-weight: 800; }
   .review-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin: 20px 0; }
   .review-col h4 { margin-bottom: 8px; font-size: 14px; text-transform: uppercase; }
   .review-col.good h4 { color: #059669; } .review-col.bad h4 { color: #DC2626; }
   .ai-rewrite-box { background: #FDF4FF; padding: 16px; border-radius: 8px; border: 1px dashed #D8B4FE; }
                .profile-page-container { background-color: #F0F2F4; min-height: 100vh; padding-top: 100px; padding-bottom: 60px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; color: #111827; }
                .loading-screen { 
                    background-color: #F0F2F4; height: 100vh; display: flex; align-items: center; justify-content: center; color: #6B7280; font-size: 16px; font-weight: 500;
                }
                .profile-grid { max-width: 1100px; margin: 0 auto; padding: 0 16px; display: grid; grid-template-columns: 2fr 1fr; gap: 24px; }
                @media (max-width: 768px) { .profile-grid { grid-template-columns: 1fr; } }
                .profile-card { background: white; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.08); border: 1px solid #E5E7EB; overflow: hidden; margin-bottom: 24px; position: relative; }
                .header-card { margin-bottom: 24px; max-width: 1100px; margin-left: auto; margin-right: auto; }
                .cover-photo { height: 180px; background: linear-gradient(135deg, #EFF6FF, #DBEAFE); }
                .header-i { padding: 0 24px 24px; margin-top: -80px; display: flex; align-items: center; gap: 24px; flex-direction: column;}
                @media (max-width: 600px) { .header-info { flex-direction: column; align-items: center; text-align: center; margin-top: -60px; } }
                .avatar-wrapper { position: relative; cursor: pointer; z-index: 10; }
                .avatar-img { width: 160px; height: 160px; border-radius: 50%; border: 5px solid white; object-fit: cover; background: white; }
                .avatar-placeholder { width: 160px; height: 160px; border-radius: 50%; border: 5px solid white; background: #2563EB; color: white; font-size: 64px; display: flex; align-items: center; justify-content: center; font-weight: bold; }
                .avatar-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.4); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; opacity: 0; transition: opacity 0.2s; border: 5px solid transparent; }
                .avatar-wrapper:hover .avatar-overlay { opacity: 1; }
                .user-details { flex: 1; padding-bottom: 10px; width: 100%; display: flex; flex-direction: column; alignItems: center; }
                .user-name { font-size: 28px; font-weight: 800; color: #1F2937; margin: 0;text-align: center; }
                .user-headline { font-size: 16px; color: #4B5563; margin: 0 0 8px 0; font-weight: 500;text-align: center; }
                .user-meta { display: flex; gap: 16px; color: #6B7280; font-size: 14px; justify-content: center; margin-bottom: 12px; }
                @media (max-width: 600px) { .user-meta { justify-content: center; } }
                .user-meta span { display: flex; align-items: center; gap: 6px; }
                .bio-container {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #E5E7EB;
    width: 100%;
    display: flex;
    justify-content: center;
}
.user-bio { 
    font-size: 15px; 
    color: #4B5563; 
    line-height: 1.6; 
    font-style: italic; 
    text-align: center; 
    max-width: 700px; /* Giới hạn độ rộng để không bị tràn */
}
                .btn-edit-absolute { position: absolute; top: 20px; right: 20px; background: rgba(34, 27, 27, 0.2); border: none; color: white; width: 36px; height: 36px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: background 0.2s; z-index: 10; }
                .btn-edit-absolute:hover { background: rgba(255,255,255,0.4); }
                .card-header { display: flex; justify-content: space-between; align-items: center; padding: 16px 24px; border-bottom: 1px solid #F3F4F6; }
                .card-header h2 { font-size: 18px; font-weight: 700; margin: 0; color: #1F2937; }
                .btn-icon { background: none; border: none; cursor: pointer; color: #6B7280; padding: 8px; border-radius: 50%; transition: bg 0.2s; }
                .btn-icon:hover { background: #F3F4F6; color: #2563EB; }
                .card-body { padding: 24px; }
                .timeline-list { display: flex; flex-direction: column; gap: 24px; }
                .timeline-item { display: flex; gap: 16px; }
                .timeline-icon { width: 48px; height: 48px; background: #F9FAFB; border-radius: 8px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; color: #4B5563; }
                .timeline-icon.school { color: #2563EB; background: #EFF6FF; }
                .timeline-content { flex: 1; }
                .item-header { display: flex; justify-content: space-between; align-items: flex-start; }
                .item-title { font-size: 16px; font-weight: 700; color: #111827; margin: 0 0 2px 0; }
                .item-subtitle { font-size: 14px; color: #1F2937; margin: 0; }
                .item-date { font-size: 13px; color: #6B7280; margin-top: 2px; }
                .item-desc { font-size: 14px; color: #4B5563; margin-top: 8px; line-height: 1.5; white-space: pre-line; }
                .item-actions { display: flex; gap: 8px; opacity: 0; transition: opacity 0.2s; }
                .timeline-item:hover .item-actions { opacity: 1; }
                .item-actions button { background: none; border: none; cursor: pointer; color: #9CA3AF; }
                .item-actions button:hover { color: #2563EB; }
                .item-actions button.text-red:hover { color: #EF4444; }
                .skills-container { display: flex; flex-wrap: wrap; gap: 8px; }
                .skill-tag { background: #EFF6FF; color: #2563EB; padding: 6px 12px; border-radius: 20px; font-size: 14px; font-weight: 500; border: 1px solid #BFDBFE; cursor: pointer; }
                .skill-tag.suggestion { background: #F3F4F6; color: #4B5563; border: 1px solid #E5E7EB; }
                .skill-tag.suggestion:hover { background: #E5E7EB; }
                .skill-tag.selected { background: #EFF6FF; color: #2563EB; border-color: #2563EB; }
                
                .link-list { display: flex; flex-direction: column; gap: 12px; }
                .link-item { text-decoration: none; color: #2563EB; font-weight: 500; font-size: 14px; display: flex; align-items: center; gap: 8px; }
                .link-item:hover { text-decoration: underline; }
                .empty-state { color: #9CA3AF; font-style: italic; font-size: 14px; text-align: center; width: 100%; }
                .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 20px; }
                .modal-container { background: white; width: 100%; max-width: 600px; border-radius: 12px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); overflow: hidden; animation: slideUp 0.3s ease-out; }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
                .modal-header { padding: 16px 24px; border-bottom: 1px solid #E5E7EB; display: flex; justify-content: space-between; align-items: center; }
                .modal-header h3 { margin: 0; font-size: 18px; font-weight: 700; }
                .btn-close { background: none; border: none; cursor: pointer; color: #6B7280; font-size: 20px; }
                .modal-body { padding: 24px; max-height: 70vh; overflow-y: auto; }
                .form-grid { display: grid; gap: 16px; }
                .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
                .form-group { display: flex; flex-direction: column; gap: 6px; }
                .form-group label { font-size: 14px; font-weight: 600; color: #374151; }
                .form-group input, .form-group textarea, .form-group select { padding: 10px; border: 1px solid #D1D5DB; border-radius: 6px; font-size: 14px; color: #111827; outline: none; }
                .form-group input:focus, .form-group textarea:focus { border-color: #2563EB; box-shadow: 0 0 0 2px rgba(37,99,235,0.1); }
                /* FIX DATE PICKER */
                input[type="date"] {
                    display: block;
                    -webkit-appearance: none;
                    min-height: 40px; 
                }
                
                .checkbox-group { flex-direction: row; align-items: center; gap: 8px; }
                .checkbox-group input { width: auto; }
                .modal-footer { padding: 16px 24px; border-top: 1px solid #E5E7EB; display: flex; justify-content: flex-end; gap: 12px; }
                .btn-primary { background: #2563EB; color: white; padding: 10px 20px; border-radius: 20px; border: none; font-weight: 600; cursor: pointer; }
                .btn-primary:hover { background: #1D4ED8; }
                .btn-secondary { background: white; color: #4B5563; padding: 10px 20px; border-radius: 20px; border: 1px solid #D1D5DB; font-weight: 600; cursor: pointer; }
                .btn-secondary:hover { background: #F3F4F6; }
                .toast-message { position: fixed; top: 80px; right: 20px; padding: 12px 24px; border-radius: 8px; color: white; font-weight: 500; box-shadow: 0 4px 6px rgba(0,0,0,0.1); z-index: 2000; animation: fadeIn 0.3s; }
                .toast-message.success { background: #10B981; }
                .toast-message.error { background: #EF4444; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
                
                /* Uni Search */
                .uni-search-container { position: relative; }
                .uni-dropdown { position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #D1D5DB; border-radius: 6px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); z-index: 10; max-height: 200px; overflow-y: auto; }
                .uni-item { padding: 10px; cursor: pointer; display: flex; gap: 10px; align-items: center; }
                .uni-item:hover { background: #F3F4F6; }
                .uni-name { font-weight: 600; font-size: 14px; }
                .uni-web { font-size: 12px; color: #6B7280; }
                
                .reactEasyCrop_Container { border-radius: 8px; overflow: hidden; }
                
                /* FIX DROPDOWN Z-INDEX */
                .navbar { z-index: 10000 !important; position: relative; }
                .user-dropdown-modern { z-index: 10001 !important; }
            `}</style>
        </div>
    );
}